import Button from '../../../../../../components/Button';
import React, { useState } from 'react';
import RelatedTagModal from './RelatedTagModal/RelatedTagModal';

interface RelatedTagButtonProps {
  tagId: number;
}

const RelatedTagButton = (props: RelatedTagButtonProps) => {
  const { tagId } = props;
  const [isRelatedTagModalOpen, setIsRelatedTagModalOpen] = useState(false);

  return (
    <>
      <Button isRadius color="primary" text="태그 보기" onClick={() => setIsRelatedTagModalOpen(true)} />
      {isRelatedTagModalOpen && <RelatedTagModal tagId={tagId} onClose={() => setIsRelatedTagModalOpen(false)} />}
    </>
  );
};

export default RelatedTagButton;
